module.exports = __webpack_public_path__ + "9ce9eba38351c1d1b79f674199cf80a8.pdf";